import styled from 'styled-components'

export const CurrencySelectContainer = styled.div`
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
`

export const CurrencySelectWrapper = styled.div`
	position: relative;
	width: 100%;
`

export const CurrencyInput = styled.input`
	width: 100%;
	padding: 12px 48px 12px 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	background-color: white;
	cursor: pointer;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}

	&[readonly] {
		cursor: pointer;
	}
`

export const SearchIcon = styled.span`
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	color: #6b7280;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const CurrencyDropdown = styled.div`
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	background: white;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	box-shadow:
		0 10px 15px -3px rgba(0, 0, 0, 0.1),
		0 4px 6px -2px rgba(0, 0, 0, 0.05);
	max-height: 300px;
	overflow-y: auto;
	z-index: 2000;
`

export const CurrencyDropdownItem = styled.div<{ $isSelected: boolean }>`
	padding: 12px 16px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 4px;
	transition: background-color 0.15s;
	background-color: ${({ $isSelected }) => ($isSelected ? '#eff6ff' : 'white')};

	&:hover {
		background-color: ${({ $isSelected }) => ($isSelected ? '#dbeafe' : '#f9fafb')};
	}

	&:first-child {
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}

	&:last-child {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
`
